import axios from '@/utils/axios';

export function getHomeDialogContent() {
    return axios({
        url: '/sysOpt/home/content',
        method: 'get'
    });
}